import {useForm, router} from '@inertiajs/react';
import {PageProps} from '@/types';
import ObituaryList from "@/Organisms/Obituaries/ObituaryList";
import ObituarySearch from "@/Organisms/Obituaries/ObituarySearch";
import Onboarding from "@/Organisms/CallToAction/Onboarding";
import NewsletterSubscribe from "@/Organisms/Newsletter/Subscribe";
import Pagination from "@/Molecules/Pagination/Pagination";
import Page from "@/Pages/Page";
import {useEffect, useState} from "react";
import {CommercialPageType} from "@/Atoms/Commercial";
import AdvertisementSection from "@/Organisms/Advertisements/AdvertisementSection";
import objectToSearchQuery from "@/helpers/objectToSearchQuery";
import SaveSearchModal from "@/Organisms/Modals/SaveSearchModal";
import {ListOption} from "@/Atoms/Select/Select";
import provinceList from "@/helpers/provinceList";
import EmailSvg from '@/Atoms/Icons/email.svg'
import {useApp} from "@/Providers/AppProvider";
import useKaChing from "@/helpers/useKaChing";
import Icon from "@/Atoms/Icons/Icon";
import Info from "@/Molecules/Info/Info";

export function removeNull<T>(obj: T | any) {
  Object.keys(obj).forEach((key) => {
    if (obj[key] && typeof obj[key] === 'object') removeNull(obj[key])
    else if (obj[key] == null) delete obj[key]
  })
  return obj
}

export type ObituarySearchType = {
  firstName: string,
  lastName: string,
  birthDate: string,
  dateOfPlacing: string,
  deceasedFrom: string,
  deceasedTo: string,
  papers: string[],
  // place?: ListOption,
  places: {
    id: string
    title: string
  }[],
  province?: {
    id: string
    title: string
  }
  page: number,
  fuzzySearch: boolean,
}

export default function Overview(
  {
    obituaries,
    errors: initialErrors,
    search,
    papers,
    ...props
  }: PageProps<{
  obituaries: {
    amount: number,
    page: number,
    pages: number
    items: [],
  },
  errors: any,
  search: any,
  papers: ListOption[]
}>) {


  const [showSaveSearchModal, setShowSaveSearchModal] = useState(false)



  const {data, setData, post, processing, errors, setError, clearErrors, reset} = useForm<ObituarySearchType>({
    firstName: '',
    lastName: '',
    birthDate: '',
    dateOfPlacing: '',
    deceasedFrom: '',
    deceasedTo: '',
    papers:  [],
    places: [],
    // place: undefined,
    // province: '',
    page: 0,
    fuzzySearch: false,

  });

  type SaveSearchFormProps = {
    name: string
    email: string
    query: any
    newsletter: boolean
  }

  
  const saveSearchForm = useForm<SaveSearchFormProps>();

  // map data to query

  const province = provinceList().find((d => d.id === data.province?.id));

  const query = {
    first_name: data.firstName,
    last_name: data.lastName,
    birth_date: data.birthDate,
    placement_date: data.dateOfPlacing,
    deceased_date_from: data.deceasedFrom,
    deceased_date_to: data.deceasedTo,
    places: data.places,
    province: province ? {
      id: province.id,
      title: province.title
    } : undefined,
    papers: data.papers.map(paper => ({id: paper, title: paper})),
  }

  const useLegacyWidget = props.legacy_widget;

  useEffect(() => {
    // @ts-ignore
    setData<ObituarySearchType>({
      birthDate: search.birthDate ?? '',
      dateOfPlacing: search.dateOfPlacing ?? '',
      deceasedFrom: search.deceasedFrom ?? '',
      deceasedTo: search.deceasedTo ?? '',
      page: 0,
      fuzzySearch: search.fuzzySearch ?? false,
      papers: search.papers ?? [],
      places: search.places ?? [],
      province: search.province ?? '',
      firstName: search.firstName ?? '',
      lastName: search.lastName ?? '',
    })
    setError(initialErrors)
  }, []);

  const handleSearch = (page: number = 0) => {
    setData('page', page)

    const objectToSearchQuery1 = objectToSearchQuery({...data, page});
    let url = '/overlijdensberichten' + objectToSearchQuery1;
    router.get(url)

    // useKaChing(url, CommercialPageType.ObituaryIndex, 'obituaries')
  }

  const handleSaveSearchModel = () => {

  }

  const handleReset = () => {
    reset();
    // setTimeout(() => {
    //   handleSearch()
    // }, 200)
    //
  }

  return (
    <Page title={'Overlijdensberichten'} pageType={CommercialPageType.ObituaryIndex} adUnit={'obituaries'} harvestId={100}>

      <section className={'section-b'}>
        <div className="container">
          <div className={'intro'}>
          <h1>Zoek overlijdensberichten</h1>
          </div>
          <ObituarySearch
            data={data}
            errors={errors}
            setData={setData}
            reset={() => reset()}
            onSubmit={handleSearch}
            papers={papers}
          />
          <div className={'flex justify-end gap-2 mt-2'}>
            <div className={'cursor-pointer hover:text-red-700'}>
              <Icon src={EmailSvg} />
              <span onClick={() => setShowSaveSearchModal(true)}>Bewaar zoekopdracht</span>
              {/*<span onClick={() => setShowSaveSearchModal(true)}>.</span>*/}
            </div>
            <Info>Bewaar de zoekopdracht en ontvang wekelijks de overlijdensberichten die hieraan voldoen in de mailbox. Je kunt meerdere zoekopdrachten opslaan, en je kunt de zoekopdracht(en) altijd aanpassen of verwijderen.</Info>
          </div>
        </div>
      </section>
      <section className="bg-beige section-a">
        <div className="container">
          <div className={'intro'}>
            <h2>Overlijdensberichten</h2>
            <p>Hieronder zie je de zoekresultaten van jouw zoekopdracht.</p>
            <p>Heb je niet de gewenste persoon gevonden? Controleer de naam of selecteer 'Ruimer zoeken'.</p>
          </div>
          <ObituaryList obituaries={obituaries.items}/>
          <Pagination page={obituaries.page} pages={obituaries.pages} onChange={(page) => {handleSearch(page)} } />
        </div>
      </section>

      <SaveSearchModal
        isOpen={showSaveSearchModal}
        onSubmit={handleSaveSearchModel}
        onCancel={() => setShowSaveSearchModal(false)}
        query={query}
      />
      {!useLegacyWidget && <>
        <Onboarding/>

        <AdvertisementSection className={'bg-beige'} />

        <NewsletterSubscribe />
      </>}
    </Page>
  );
}
